import React, { useState, useEffect } from 'react';
import {
	Navigate,
	NavLink,
	Route,
	Routes,
	// useLocation,
	useNavigate
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Icofont from 'react-icofont';
import { Tabs } from 'antd-mobile';
import { pushStateHistoryModal, GETWITH, POST, publish, QueryOrder, QueryParam, subscribe, TranslateContext, unsubscribe, useAuth, UserConfigContext, UserContext, LanguageContext } from 'fennec-ui';
import REDUX_Pari from '../../../objects/Pari/reducer';
import CRUDE_Pari from '../../../objects/Pari/crude';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import CRUDE_VseTipiPolzovatelei from '../../../objects/VseTipiPolzovatelei/crude'
import './index.less';
import { errorCatch, QueryDetail, READWITH } from 'fennec-ui';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { MetaContext } from 'fennec-ui';
import { access, defaultRoute, item, translate } from '../../../common/Tool';
import LangSwitchMobile from '../../components/LangSwitchMobile';
import { BreadcrumbsProvider, LangSwitchContext, MenuLevelOneContext, useLangSwitchContext } from '../../../common/Context';
import Common from './Common';
import Admin from './Admin';
import Sidebar from '../../components/Sidebar';
import SiteAccessDeny from '../../../desktop/pages/SiteAccessDeny';
import AdminMainResourceLocks from '../../../desktop/pages/AdminMainResourceLocks';
import ContextRoute, { ContextList } from '../ContextRoute';
import { ContextGetpromoElement, ContextLocaladminElement, ContextOrganizerElement, ContextSchoolElement, ContextTeacherElement, ContextTestingElement } from '../../components/ContextElement';
import AttestationTesting from './Testing';
import Promo from './Promo';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import School from './School';
import Organizer from './Organizer';
import Teacher from './Teacher';
import Kurator from './Kurator';
import Promouter from './Promouter';
import Artist from './Artist';
import { createContext } from 'react';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');


// function School(props) {
// 	return (<React.Fragment></React.Fragment>)
// }
// function Localadmin(props) {
// 	return (<React.Fragment></React.Fragment>)
// }
// function Organizer(props) {
// 	return (<React.Fragment></React.Fragment>)
// }
// function Teacher(props) {
// 	return (<React.Fragment></React.Fragment>)
// // }
// function EventsAdmin(props) {
// 	return (<React.Fragment></React.Fragment>)
// }
// function Kurator(props) {
// 	return (<React.Fragment></React.Fragment>)
// }
// function Promouter(props) {
// 	return (<React.Fragment></React.Fragment>)
// }
// function Artist(props) {
// 	return (<React.Fragment></React.Fragment>)
// }

const menu = (status, notify) => {
	const x = [
		{
			uuid: "common",
			default: true,
			name: "Общее",
			component: (props) => (<Common {...props} />),
			role: [
				{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
			],
			// loader: async ({ request, params }) => {
			// 	return fetch(
			// 		`/fake/api/teams/${params.teamId}.json`,
			// 		{ signal: request.signal }
			// 	);
			// },
			// handle: {
			// 	crumb: () => <Link to="/message">Messages</Link>,
			// },
		},
		{
			uuid: "testing",
			name: "Судейская аттестация",
			unvisible: true,
			color: "#738678",
			component: (props) => (
				<ContextRoute uuid=":id"
					display={(item) => <ContextTestingElement item={item} color={"#738678"} />}
					displayString={(item) => item?.kategoriyaSudeistva?.nazvanieKategorii + " - " + item?.kategoriyaSudeistva?.tanets?.nazvanie}
					params={[
						QueryOrder("kategoriyaSudeistva.nazvanieKategorii", "ASC"),
						QueryOrder("kategoriyaSudeistva.tanets.nazvanie", "ASC"),
						QueryDetail("model")
					]}
					listSource="/api/testisudeiskikhattestatsii/listbysudya"
					list={<ContextList {...props}
						params={[
							QueryOrder("kategoriyaSudeistva.nazvanieKategorii", "ASC"),
							QueryOrder("kategoriyaSudeistva.tanets.nazvanie", "ASC"),
							QueryDetail("collection")
						]} />}

					itemSource="/api/testisudeiskikhattestatsii/listbysudya"
					item={<AttestationTesting {...props} />}
				/>),
			role: [
				{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
			],
		},
		{
			uuid: "getpromo",
			name: "Получение промокода",
			unvisible: true,
			color: "#FF7900", // #3B3C36
			component: (props) => (
				<ContextRoute uuid=":id"
					display={(item) => <ContextGetpromoElement item={item} color={"#FF7900"} />}
					displayString={(item) => item?.nazvanieMeropriyatiya
					}
					params={[
						// QueryParam("page", "1"),
						QueryParam("w-eq-promokodiMeropriyatie.shablonniiPromokod", "true"),
						QueryParam("w-eq-isPublic", "true"),
						QueryOrder("nachaloSorevnovaniya", "DESC"),
						QueryParam("w-lge-okonchanieSorevnovaniya", dayjs().format("YYYY-MM-DD")),
						QueryDetail("model")
					]}
					listSource="/api/meropriyatiya/list/com"
					list={<ContextList
						{...props}
						style={{ height: "100%", overflow: "auto", flex: "auto" }}
						title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>Выберите мероприятие по которому хотите получить промокод</div>}
						empty={<div>Нет доступных мероприятий</div>}
					/>}

					itemSource="/api/meropriyatiya/list/com"
					item={<Promo {...props} />}
				/>),
			role: [
				{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
			]
		},

		// {
		// 	uuid: "local",
		// 	name: "Региональное отделение",
		// 	color: "#02c0cb",
		// 	component: (props) => (
		// 		<ContextRoute uuid=":id"
		// 			display={(item) => <ContextLocaladminElement item={item} color={"#02c0cb"} />}
		// 			displayString={(item) => item?.nazvanie}
		// 			params={[
		// 				QueryOrder("nazvanie", "ASC")
		// 			]}
		// 			listSource="/api/ro/list-by-admin"
		// 			list={<ContextList {...props}
		// 				style={{ height: "100%", overflowY: "auto" }} />}

		// 			itemSource="/api/ro/list-by-admin"
		// 			item={<Localadmin {...props} />}
		// 		/>),
		// 	role: [
		// 		{ "ID": 14, "nazvanie": "АдминистраторОбщегоСобрания" },
		// 		{ "ID": 15, "nazvanie": "АдминистраторОтделения" },
		// 		{ "ID": 29, "nazvanie": "АдминистраторМероприятийРО" },
		// 	],
		// },
		{
			uuid: "school",
			name: "Школа",
			color: "#eae2b7",
			component: (props) => (
				<ContextRoute uuid=":id"
					display={(item) => <ContextSchoolElement item={item} color={"#eae2b7"} />}
					displayString={(item) => item?.nazvanieShkoliTantsev}
					params={[
						QueryOrder("nazvanieShkoliTantsev", "ASC")
					]}
					listSource="/api/school/list-by-admin"
					list={<ContextList {...props} style={{ height: "100%", overflowY: "auto" }} />}

					itemSource="/api/school/list-by-admin"
					item={<School {...props} />}
				/>),
			role: [
				{ "ID": 18, "nazvanie": "ВладелецШколыФедерации" },
				{ "ID": 19, "nazvanie": "АдминистраторШколыФедерации" },
				{ "ID": 20, "nazvanie": "АдминистраторКоллективаФедерации" },
			],
		},
		{
			uuid: "organizer",
			name: "Организатор",
			color: "#a2d2ff",
			component: (props) => (
				<ContextRoute uuid=":id"
					display={(item) => <ContextOrganizerElement item={item} color={"#a2d2ff"} />}
					displayString={(item) => item?.nazvanie}
					params={[
						QueryOrder("nazvanie", "ASC")
					]}
					listSource="/api/org/list-by-admin"
					list={<ContextList {...props}
						style={{ height: "100%", overflowY: "auto" }} />}

					itemSource="/api/org/list-by-admin"
					item={<Organizer {...props} />}
				/>),
			role: [
				{ "ID": 23, "nazvanie": "ОрганизаторФедерации" },
				{ "ID": 25, "nazvanie": "АдминистраторОрганизатораФедерации" }
			],
		},
		{
			uuid: "teacher",
			name: "Преподаватель",
			color: "#FF9933",
			component: (props) => (
				<ContextRoute uuid=":id"
					display={(item) => <ContextTeacherElement item={item} color={"#FF9933"} />}
					displayString={(item) => item?.regionalnoeOtdelenie?.nazvanie}

					listSource="/api/prepodavateli-federatsii/list-by-admin"
					list={<ContextList {...props}
						style={{ height: "100%", overflowY: "auto" }}
						queryDetail={"model"}
						params={[
							QueryOrder("user.lastname", "ASC"),
							QueryOrder("user.firstname", "ASC"),
							QueryOrder("regionalnoeOtdelenie.nazvanie", "ASC"),
						]}
						title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>Выберите одно из региональных отделений, в котором вы зарегистрированы </div>}
						empty={<div>Нет доступных региональных отделений</div>}
					/>}

					itemSource="/api/prepodavateli-federatsii/list-by-admin"
					item={<Teacher {...props}
						params={[
							QueryOrder("user.lastname", "ASC"),
							QueryOrder("user.firstname", "ASC"),
							QueryOrder("regionalnoeOtdelenie.nazvanie", "ASC"),
							QueryDetail("model"),
						]} />}
				/>),
			role: [
				{ "ID": 21, "nazvanie": "ПреподавательФедерации" }
			],
		},
		// {
		// 	uuid: "events-admin",
		// 	name: "Администратор мероприятия",
		// 	color: "#ffc8dd",
		// 	component: (props) => (<EventsAdmin {...props} />),
		// 	role: [
		// 		{ "ID": 30, "nazvanie": "АдминистраторМероприятия" },
		// 	]
		// },
		{
			uuid: "kurator",
			name: "Куратор",
			color: "#f058dd",
			component: (props) => (<Kurator {...props} />),
			role: [
				{ "ID": 33, "nazvanie": "Куратор" },
			]
		},
		{
			uuid: "promouter",
			name: "Промоутер",
			color: "#2a9d8f",
			component: (props) => (<Promouter {...props} />),
			role: [
				{ "ID": 34, "nazvanie": "Промоутер" },
			]
		},
		{
			uuid: "artist",
			name: "Артист",
			color: "#ccd5ae",
			component: (props) => (<Artist {...props} />),
			role: [
				{ "ID": 35, "nazvanie": "Артист" },
			]
		},

		{
			uuid: "admin",
			default: true,
			name: "Админ",
			component: (props) => (<Admin {...props} />),
			role: [
				{ "ID": 28, "nazvanie": "СуперАдмин" },
			],
		},

	]
	return x
};

function Home(props) {
	let navigate = useNavigate();
	const langSwitch = useLangSwitchContext();
	const auth = useAuth();
	const { history } = props;
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang")||"ru") })
	const translates = useSelector(REDUX_Translate.selector.object);
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const meta = useSelector(state => state.meta);
	const user = useSelector(state => state.home.user);
	const role_by_id = useSelector(state => state.home.role_by_id);
	const status = useSelector(state => state.home.status);
	const notify = useSelector(state => state.home.notify);
	const siteAccess = useSelector(state => state.siteAccess.value);

	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	const [online, setOnline] = useState(false);
	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	useEffect(
		() => {
			_subscribe();
			return () => {
				_unsubscribe();
			};
		},
		[ /* TODO: memoization parameters here */]
	);

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryOrder("akkaunt.akkauntType.ID", "ASC"),
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const uuid = "53f2ffd3d9a5";
	useEffect(() => {
		let token = subscribe("service.status", function (msg, data) {
			if (msg.startsWith(`service.status.${uuid}`)) {
				return
			}
			dispatch({ type: 'STATUS-UPDATE', payload: data })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	useEffect(() => {
		let token = subscribe("service.notify", function (msg, data) {
			if (msg.startsWith(`service.notify.${uuid}`)) {
				return
			}
			dispatch({ type: 'NOTIFY-UPDATE', payload: data })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	const _subscribe = () => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				dispatch({ type: 'USER', payload: res.data })
			}
		});
		READWITH(auth, 'Translate', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				let o = Object.fromEntries(data.map(i => {
					return [
						i.key,
						{
							ru: i.ru,
							en: i.en,
							es: i.es,
							tr: i.tr,
						},
					]
				}));
				dispatch(REDUX_Translate.actions.setObject(o));
			}
		}, errorCatch)
		READWITH(auth, 'UserConfig', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				var obj = Object.fromEntries(data.map(i => {
					return [
						i.key,
						i.value
					]
				}));
				dispatch(REDUX_UserConfig.actions.setObject(obj));
			}
		}, errorCatch)
		RefreshAkkaunti();
		CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
			if (data.length > 0) {
				// dispatch(REDUX_VseTipiPolzovatelei.actions.setArray(data));
				dispatch({ type: 'ROLE', payload: data });
			}
		}, 'model', 's-id=ASC');
		auth.openSocket("/ws/service", "service",
			//onmessage
			function (type, payload) {
				if (type === "reload") {
					window.location.href = window.location.href;
				}
				switch (type) {
					case "siteaccess":
						dispatch({ type: "SITE_ACCESS", payload: payload });
						break;
					case "role":
						dispatch({ type: 'ROLE-UPDATE', payload: [payload] })
						break;
					case "status":
						publish(`service.${type}.${uuid}`, [payload]);
						dispatch({ type: 'STATUS-UPDATE', payload: [payload] })
						break;
					case "notify":
						publish(`service.${type}.${uuid}`, [payload]);
						dispatch({ type: 'NOTIFY-UPDATE', payload: [payload] })
						break;
					case "predlozhenierukiiserdtsa":
						dispatch(REDUX_Pari.actions.updateArray([payload]));
						break;
					case "polozhitelniiotvetnapredlozhenierukiiserdtsa":
						dispatch(REDUX_Pari.actions.updateArray([payload]));
						break;
					case "AkkauntiPolzovatelei":
						dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
						break;
					case "NeedUpdateAkkauntPolzovatelya":
						RefreshAkkaunti();
						break;
					default:
						publish("service." + type, payload);
						break;
				}
			},
			//onopen
			function () {
				setOnline(true);
			},
			//onclose
			function () {
				setOnline(false);
			}
		);

		GETWITH(auth, '/api/query/InterfeisiInfrastrukturnikhStatusov', [
			QueryDetail("model"),
			QueryOrder("status.DataPoslednegoIzmeneniya", "DESC"),
			QueryParam("w-TipNovayaInfa", "true"),
			QueryParam("w-status.Arkhiv", "false")
		],
			({ data }) => {
				dispatch({ type: 'STATUS', payload: data })
			}, errorCatch);
		GETWITH(auth, '/api/query/InfrastrukturnieUvedomleniya', [
			QueryDetail("model"),
			QueryOrder("Data", "DESC"),
			QueryParam("w-eqOrNu-Prochitano", "false"),
		], ({ data }) => {
			dispatch({ type: 'NOTIFY', payload: data })
		}, errorCatch);
		CRUDE_Pari.read(auth, (data) => {
			if (data.length > 0) {
				dispatch(REDUX_Pari.actions.setArray(data?.filter(item => !item.dokumentVikhodaID)));
			}
		}, 'model', 's-id=ASC');
	};
	const _unsubscribe = () => {
		auth.closeSocket("service");
	};
	const logout = () => {
		auth.logout(() => {
			navigate('/app');
		});
	}

	const stack = [];
	const getStack = React.useCallback(() => {
		return stack;
	}, []);

	const [open, setOpen] = useState(false);
	const menuClose = () => {
		if (open) {
			window.history.back();
		}
	}
	const onOpenChange = () => {
		if (!open) {
			pushStateHistoryModal(setOpen, getStack);
			setOpen(true);
			return
		}
		menuClose();
	}

	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitchMobile userConfig={userConfig} />}>
								<div className='app mobile'>
									<div className='header' style={{ display: "flex", justifyContent: "space-between", backgroundColor: "#001529" }}>
										<a href="/">
											<div style={{ flex: 0 }}>
												<div className="logo-mobile" />
											</div>
										</a>
										<div style={{ flex: 0 }}>
											<div className='sider-button'>
												<Icofont key="1" icon="navigation-menu" onClick={onOpenChange} />
											</div>
											<Sidebar open={open} menu={menu} menuClose={menuClose} getStack={getStack} />
										</div>
									</div>
									<div className='content' style={{ background: "#f5f5f5" }}>
										<MenuLevelOneContext.Provider value={menu(status, notify)}>
											{(!siteAccess || siteAccess == "allow") && <Routes>
												{defaultRoute(menu(status, notify), role_by_id)}
												{menu(status, notify).map((e, idx) => {
													if (e.component && access(e, role_by_id)) {
														return <Route key={e.uuid} path={(e.uuid !== "*") ? e.uuid + "/*" : "*"} element={
															<BreadcrumbsProvider value={{
																uuid: e?.uuid,
																name: e?.name,
																color: e?.color,
																role: e?.role,
																hidden: e.hidden
															}}>
																{e.component({})}
															</BreadcrumbsProvider>} />
													}
												})}
											</Routes>}
											{(siteAccess == "deny") &&
												<Routes>
													<Route exact path="admin" element={<AdminMainResourceLocks {...props} auth={auth} />} />
													<Route exact path="admin/main/resource-locks" element={<AdminMainResourceLocks {...props} auth={auth} />} />
													<Route path="*" element={<SiteAccessDeny {...props} auth={auth} />} />
												</Routes>}
										</MenuLevelOneContext.Provider>
									</div>
								</div>
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider>
	);
};

export default Home;